<template>
	<!-- 门店生熟客 -->
	<keep-alive>
		<div style="">
			<span style="margin: 10px;">月份</span>
			<el-date-picker @change="getlist()" value-format="yyyy-MM" size="small" v-model="filter.month"
				style="width: 150px;position: relative;z-index: 100;" type="month" placeholder="选择月">
			</el-date-picker>
			<span style="margin: 10px;">门店</span>
			<el-select @change="getlist()" v-model="filter.storeId" placeholder="全部门店" clearable
				style="width: 160px;margin-right:10px;" size="small">
				<el-option-group label="营业门店" class="store">
					<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
					</el-option>
				</el-option-group>
				<el-option-group label="结业门店">
					<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
					</el-option>
				</el-option-group>
				</el-option>
			</el-select>
			<span style="margin: 10px;">属性</span>
			<el-select v-model="filter.type" size="small" @change="getlist()" placeholder="门店属性" style="width: 120px"
				clearable>
				<el-option label="普通店" value="1"></el-option>
				<el-option label="合作店" value="2"></el-option>
				<el-option label="联名店" value="3"></el-option>
				<el-option label="旗舰店" value="4"></el-option>
				<el-option label="地铁店" value="5"></el-option>
				<el-option label="加盟店" value="6"></el-option>
			</el-select>
			<el-button type="primary" style=" position: relative;z-index: 100;margin-left:10px ;" @click="getlist()"
				size="small">筛 选</el-button>
			<el-button type="infor" @click="export01()" size="small">导 出</el-button>
			<el-table :data="list" v-loading="loading"
				:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D'}"
				:cell-style="{ 'text-align':'center'}">
				<el-table-column label="门店">
					<template slot-scope="{row}">
						{{row.storeName}}
					</template>
				</el-table-column>
				<el-table-column label="门店属性">
					<template slot-scope="{row}">
						{{row.type | typeFormat}}
					</template>
				</el-table-column>
				<el-table-column label="当月业绩" prop="total" sortable>
					<template slot-scope="{row}">
						{{row.total}}
					</template>
				</el-table-column>
				<el-table-column label="业绩月同比" prop="compare" sortable>
					<template slot-scope="{row}">
						<div v-if="row.compare < 0" class="content Red">{{row.compare/100}}%</div>
						<div v-else class="content Green">+{{row.compare/100}}%</div>
					</template>
				</el-table-column>
				<el-table-column label="剪发新/老客数">
					<template slot-scope="{row}">
						{{row.newHair?row.newHair:0}}/{{row.oldHair?row.oldHair:0}}
					</template>
				</el-table-column>
				<el-table-column label="权益新/老客数">
					<template slot-scope="{row}">
						{{row.newMember?row.newMember:0}}/{{row.oldMember?row.oldMember:0}}
					</template>
				</el-table-column>
				<el-table-column label="新客数月同比">
					<template slot-scope="{row}">
						<div v-if="row.newCustomerRate < 0" class="content Red">{{row.newCustomerRate}}%</div>
						<div v-else class="content Green">{{row.newCustomerRate?"+"+row.newCustomerRate+"%":'0'}}</div>
					</template>
				</el-table-column>
				<el-table-column label="本月成本" prop="chengben" sortable>
					<template slot-scope="{row}">
						{{row.chengben?row.chengben:'0'}}
					</template>
				</el-table-column>
				<el-table-column label="本月盈利" prop="yingli" sortable>
					<template slot-scope="{row}">
						<div v-if="row.yingli < 0" class="content Red">{{row.yingli}}</div>
						<div v-else class="content Green">{{row.yingli?row.yingli:'0'}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="{row}">
						<el-button type="text" @click="godeatil(row)" size="small">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</keep-alive>
</template>

<script>
	import {
		url
	} from '../../../utils/index.js'
	import echarts from 'echarts'
	export default {
		data() {
			return {
				hiarlist: [],
				url: url(),
				list: [],
				total: '',
				filter: {
					month: '',
					workerName: "",
					storeId: "",
					orderBy: 'storeName',
					type: ''
				},
				//第三部分表格
				tableData: [],
				serviceList: [],
				storeEnd: [],
				storeList: [],
				pageNo: 1,
				pageSize: 50,
				level: '',
				loading: false,
				// options: [{
				// 		value: "",
				// 		label: "全部"
				// 	},
				// 	{
				// 		value: "S",
				// 		label: "S"
				// 	},
				// 	{
				// 		value: "A",
				// 		label: "A"
				// 	},
				// 	{
				// 		value: "B",
				// 		label: "B"
				// 	},
				// 	{
				// 		value: "C",
				// 		label: "C"
				// 	},
				// 	{
				// 		value: "D",
				// 		label: "D"
				// 	}
				// ],
				// chartData: {
				// 	columns: ['属性', '数量'],
				// 	rows: [{
				// 			'属性': '首次消费',
				// 			'数量': 10
				// 		},
				// 		{
				// 			'属性': '生客',
				// 			'数量': 10
				// 		},
				// 		{
				// 			'属性': '熟客',
				// 			'数量': 10
				// 		},
				// 		{
				// 			'属性': '深度熟客',
				// 			'数量': 10
				// 		},
				// 	],
				// },
				typeExted: {
					legend: {
						show: true,
						type: 'scroll',
						orient: 'vertical',
						left: 0,
						top: 0,
						bottom: 0,
						center: 0,
						icon: "circle",
						itemWidth: 5,
						itemHeight: 5,
						itemGap: 20,
					},
				},
				chartSettings: {
					offsetY: 56,
					width: 10,
					bottom: 0,
					radius: 45,
					labelLine: {
						show: false
					},
					label: {
						show: false,
					},
				},
				charts: '',
				// opinion: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎'],
				// opinionData: [{
				// 		value: 335,
				// 		name: '直接访问'
				// 	},
				// 	{
				// 		value: 310,
				// 		name: '邮件营销'
				// 	},
				// 	{
				// 		value: 234,
				// 		name: '联盟广告'
				// 	},
				// 	{
				// 		value: 135,
				// 		name: '视频广告'
				// 	},
				// 	{
				// 		value: 1548,
				// 		name: '搜索引擎'
				// 	}
				// ],
				// orderBy:[
				// 	{
				// 		value:'scoreDesc',
				// 		label:'分数降序'
				// 	},
				// 	{
				// 		value:'scoreAsc',
				// 		label:'分数升序'
				// 	},
				// 	{
				// 		value:'storeName',
				// 		label:'门店名'
				// 	},
				// ]
			}
		},
		filters: {
			typeFormat(val) {
				switch (val) {
					case "1":
						return "普通店";
					case "2":
						return "合作店";
					case "3":
						return "联名店";
					case "4":
						return "旗舰店";
					case "5":
						return "地铁店";
					case "6":
						return "加盟店";
					default:
						return "/";
				}
			}
		},
		mounted() {
			const date1 = new Date()
			const nowDay =
				`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}`
			this.filter.month = nowDay
			this.getstorelist()
			this.getlist()
			/* 			this.list.forEach(item => {
							this.$nextTick(function() {
								this.drawPie(item)
							})
						}) */
		},
		methods: {
			// 获取门店列表
			getstorelist() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			onload() {
				location.reload()
			},
			getlist() {
				this.loading = true
				var a = "?month=" + this.filter.month +
					"&storeId=" + this.filter.storeId +
					"&pageNum=" + this.pageNo +
					"&pageSize=" + this.pageSize +
					"&level=" + this.level +
					"&content=" + this.filter.orderBy +
					"&type=" + this.filter.type
				this.$http.get("dStoreFile/list" + a).then(res => {
					if (res.body.code == 200) {
						var list = res.body.data
						this.list = list
						this.list.forEach(item => {
							var b = {
								columns: ['属性', '数量'],
								rows: [{
									'属性': '首次消费',
									'数量': item.first
								}, {
									'属性': '生客',
									'数量': item.sheng
								}, {
									'属性': '熟客',
									'数量': item.shu
								}, {
									'属性': '深度熟客',
									'数量': item.shenDu
								}, ],
							}
							if (item.first == null || item.sheng == null || item.shu == null || item
								.shenDu == null) {
								b = {
									columns: ['属性', '数量'],
									rows: [{
										'属性': '首次消费',
										'数量': 1
									}, {
										'属性': '生客',
										'数量': 1
									}, {
										'属性': '熟客',
										'数量': 1
									}, {
										'属性': '深度熟客',
										'数量': 1
									}, ],
								}
							}
							item.chartData = b
						})
						this.loading = false
					}
				})
			},
			godeatil(e) {
				// 保存数据
				localStorage.setItem('storeFile', JSON.stringify(e))
				this.$router.push({
					path: '/storeFielDetail',
					query: {
						id: e.storeId
					}
				})
			},
			export01() {
				var a = "?month=" + this.filter.month +
					"&storeId=" + this.filter.storeId +
					"&pageNum=" + this.pageNo +
					"&pageSize=" + this.pageSize +
					"&level=" + this.level +
					"&type=" + this.filter.type
				window.location.assign(this.url + "dStoreFile/export" + a)
			},
			handlePageChange(val) {
				this.pageNo = val
				this.getlist()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getlist()
			}
			/* 			drawPie(item) {
							this.charts = echarts.init(document.getElementById(item.id))
							this.charts.setOption({
								tooltip: {
									trigger: 'item',
									formatter: '{a}<br/>{b}:{c} ({d}%)'
								},
								legend: {
									orient: 'vertical',
									x: 'left',
									data: this.opinion
								},
								series: [{
									name: '访问来源',
									type: 'pie',
									radius: ['50%', '70%'],
									avoidLabelOverlap: false,
									label: {
										normal: {
											show: false,
											position: 'center'
										},
										emphasis: {
											show: true,
											textStyle: {
												fontSize: '30',
												fontWeight: 'blod'
											}
										}
									},
									labelLine: {
										normal: {
											show: false
										}
									},
									data: this.opinionData
								}]
							})
						}, */
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .ve-pie canvas {
		height: 200px;
	}

	// .content {
	// 		margin-left: 5px;
	// 		text-align: center;
	// 		font-size: 20px;
	// 	}

	.Green {
		color: #008855;
	}

	.Red {
		color: #AA1111
	}

	.el-popover.my-el-popover {
		height: 50%;
		overflow: scroll;
	}

	/deep/ .el-popover__reference-wrapper {
		font-size: 10px;
	}

	.flex {
		display: flex;
	}

	.t {
		margin-top: 3px;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.blue {
		width: 5px;
		height: 15px;
		background: #409EFF;
		border-radius: 2px;
		margin-right: 8px;
		position: relative;
		top: 4px;
	}

	.top {
		width: 100%;
		height: 67px;
		background: #FFFFFF;
		box-shadow: 2px 2px 4px 2px rgba(147, 147, 147, 0.5);
		border-radius: 5px;
		box-sizing: border-box;
		margin: 20px 0px 0 0;
		padding: 20px 10px 10px 10px;
	}

	// 发型师列表
	.storelist {
		margin-left: -5px;
		min-height: 100px;
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		margin-top: 20px;

		.list {
			width: 31.00%;
			margin-left: 20px;
			margin-bottom: 20px;
			height: 210px;
			background: #FFFFFF;
			box-shadow: 1px 5px 5px 2px #e8e8e8;
			border-radius: 8px;
			border: 1px solid #dcdcdc;
			box-sizing: border-box;
			padding: 5px;

			.listtop {
				display: flex;
				padding: 5px 5px 5px 10px;

				.box1 {
					width: 80%;
					border-bottom: 1px solid #cbcbcb;

					.storeName {
						width: 100%;
						font-size: 22px;
						font-family: SourceHanSansCN-Bold, SourceHanSansCN;
						font-weight: bold;
						color: #2D2D2D;
					}

					.man {
						margin-top: 5px;

						.title {
							font-size: 14px;
							color: #7f7f7f;
						}

						.content {

							font-size: 14px;
						}
					}
				}

				.box2 {
					width: 20%;
					border-bottom: 1px solid #cbcbcb;

					.level {
						text-align: center;
						font-size: 28px;
						font-family: SourceHanSansCN-Bold, SourceHanSansCN;
						font-weight: bold;
						color: #FF0000;
						line-height: 36px;
					}

					.level2 {
						text-align: center;
						font-size: 16px;
						font-family: SourceHanSansCN-Bold, SourceHanSansCN;
						font-weight: bold;
						color: #000000;
					}
				}
			}


			.listbottom {
				display: flex;
				width: 100%;
				padding: 0px 10px 10px 15px;

				.box1 {
					margin-left: -10px;
					width: 50%;

					.block {
						width: 45%;
						margin-right: 5px;

						.content {
							margin-left: 5px;
							text-align: center;
							font-size: 20px;
						}

						.Green {
							color: #008855;
						}

						.Red {
							color: #AA1111
						}

						.btitle {
							width: 100%;
							text-align: center;
							font-size: 14px;
							color: #828282;
						}
					}

					.r02 {
						margin-top: 10px;
					}

					.borderMid {
						height: 20px;
						margin-top: 10px;
						width: 1px;
						background-color: #cbcbcb;
					}
				}

				.box2 {
					width: 45%;
					height: 100px;
					margin-left: 10px;
					// border-left: 1px solid #cbcbcb;

				}
			}
		}
	}
	/deep/.el-select-dropdown__item {
		width:220px;
	}
</style>